// extracted by mini-css-extract-plugin
module.exports = {"detailsHeading":"StepThree_detailsHeading__3IJm6"};